/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotFilters {
    getFixupPrototypeFunction() { return TagPostureSnapshotFilters.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotFilters>): TagPostureSnapshotFilters {
        let obj = Object.assign(new TagPostureSnapshotFilters(), model);
        TagPostureSnapshotFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotFilters>): TagPostureSnapshotFilters {
        if (!model) return null;
        return TagPostureSnapshotFilters.newInstance(<TagPostureSnapshotFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotFilters) {
        if (!obj) return;

        models.TagPostureSnapshotFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotFilters): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of status to filter. (All if missing)
     */
    status: Array<models.TagPostureSnapshotStatus>;

}
